module.exports = __webpack_public_path__ + "img/f_u3_moonstocking.69c0b5d5.jpg";